import { domain } from "./domain";
export type PricePreview = { ok: true; price: number; converted: boolean } | { ok: false; message: string };
export function previewPrice(input: string): PricePreview {
  const result = domain<{ ok: true; price: string; converted: boolean } | { ok: false; message: string }>({ kind: "price", input });
  return result.ok ? { ...result, price: Number(result.price) } : result;
}
